import { useLoggedOutCategoryPagePaginationData } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/hooks/useLoggedOutCategoryPagePaginationData";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { HorizontalLine } from "@faire/web--source/slate/Layout";
import { Pagination } from "@faire/web--source/slate/Pagination";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

export const LoggedOutCategoryPagePagination: React.FC<{
  scrollToTop: (params: { toResults?: boolean; toTop?: boolean }) => void;
}> = ({ scrollToTop }) => {
  const paginationData = useLoggedOutCategoryPagePaginationData();

  const getPageLinkHandler = (pageNumber: number): string => {
    const currentFilterPath = getCurrentPath().delete("page");
    if (pageNumber === 1) {
      return currentFilterPath.toString();
    }
    return currentFilterPath.append({ page: pageNumber.toString() }).toString();
  };

  const shouldShowPagination =
    paginationData && (paginationData.page_count ?? 0) > 1;

  if (!shouldShowPagination) {
    return null;
  }

  return (
    <>
      <Spacer height="3x" />
      <HorizontalLine />
      <Spacer height="3x" />
      <Pagination
        paginationData={paginationData}
        pageToLink={getPageLinkHandler}
        onChangePage={(page) =>
          scrollToTop({ toResults: true, toTop: page === 1 })
        }
      />
      <Spacer height="3x" />
      <HorizontalLine />
    </>
  );
};
